import React, { useState, useEffect } from "react"
import { Modal } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import SweetAlert from "react-bootstrap-sweetalert"
import { getCurrentUser, getPermission } from "../../../helpers/Utils"
import axios from "axios"
import LongText from "../../MessageField"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const CledgerList = props => {
  const [ledger, setLedger] = useState(props.data)
  const [editModal, setEditModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const canEditAmount =
    getCurrentUser()?.role_name === "Administrator" ||
    getPermission()?.ledger?.ledger?.edit?.is_checked === "yes"
  const canDelete =
    getPermission()?.ledger?.ledger?.delete?.is_checked === "yes"

  const deleteLedger = e => {
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/ledger/${e}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLedger("")
          if (props.getAllLedger) {
            props.getAllLedger()
          }
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
  }

  const editAmount = (e, value) => {
    setLoading(true)
    axios
      .put(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/ledger/${ledger.id}`,
        {
          amount: value.amount,
        },
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        setLoading(false)
        if (res.data.status) {
          setEditModal(false)
          if (props.getAllLedger) {
            props.getAllLedger()
          } else {
            setLedger({
              ...ledger,
              amount: res.data.data?.amount ?? value.amount,
            })
          }
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    const close = e => {
      if (e.key === "Escape") {
        setEditModal(false)
      }
    }
    window.addEventListener("keydown", close)
    return () => window.removeEventListener("keydown", close)
  }, [])

  if (ledger === "") {
    return ""
  } else
    return (
      <>
        <tr key={props.i}>
          <td>{props.counter + props.i}</td>
          <td>{ledger.id}</td>
          <td>{ledger.order_id}</td>
          <td>{ledger.amount}</td>
          <td>{ledger.transaction_date}</td>
          <td>
            <LongText content={ledger.message} />
          </td>
          <td>
            {ledger.type == "paid" ? (
              <span className="badge bg-success">Credit</span>
            ) : (
              ""
            )}
            {ledger.type == "outstanding" ? (
              <span className="badge bg-danger">Debit</span>
            ) : (
              ""
            )}
          </td>
          <td>{ledger.user_name}</td>
          <td>
            {canEditAmount ? (
              <a
                className="text-primary"
                onClick={() => setEditModal(true)}
                style={{ cursor: "pointer" }}
              >
                <i className="fas fa-edit" />
              </a>
            ) : (
              ""
            )}
            {canDelete ? (
              <a
                className="text-danger ms-2"
                onClick={() => setconfirm_alert(true)}
                style={{ cursor: "pointer" }}
              >
                <i className="fas fa-trash-alt" />
              </a>
            ) : (
              ""
            )}
            {confirm_alert ? (
              <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmButtonText="Yes, delete it!"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                  setconfirm_alert(false)
                  deleteLedger(ledger.id)
                }}
                onCancel={() => setconfirm_alert(false)}
              >
                You won't be able to revert this!
              </SweetAlert>
            ) : null}
          </td>
        </tr>
        {editModal ? (
          <Modal isOpen={editModal} centered={true}>
            <AvForm
              className="modal-title mt-0"
              onValidSubmit={(e, v) => {
                editAmount(e, v)
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title mt-0">Edit Amount</h5>
                <button
                  type="button"
                  className="cross__btn"
                  onClick={() => setEditModal(false)}
                  aria-hidden="true"
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <p className="mb-2">
                  Ledger ID: {ledger.id}
                  {ledger.order_id ? ` | Order ID: ${ledger.order_id}` : ""}
                </p>
                <div className="mb-3 required">
                  <AvField
                    label="Amount"
                    type="number"
                    name="amount"
                    min="1"
                    placeholder="Enter Amount"
                    defaultValue={ledger.amount}
                    onFocus={e =>
                      e.target.addEventListener(
                        "wheel",
                        function (event) {
                          event.preventDefault()
                        },
                        { passive: false }
                      )
                    }
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Amount is required",
                      },
                      min: {
                        value: 1,
                        errorMessage: "Amount must be at least 1",
                      },
                    }}
                  />
                </div>
              </div>
              <div className="modal-footer">
                {loading ? (
                  <button className="btn btn-primary" type="button" disabled>
                    Loading
                  </button>
                ) : (
                  <button className="btn btn-primary" type="submit">
                    Update
                  </button>
                )}
              </div>
            </AvForm>
          </Modal>
        ) : null}
      </>
    )
}
export default CledgerList
